<div [class.default-partner-navigation-bar]="isSticky">
  <div class="d-none d-sm-block navigation-bar mx-7 mx-lg-5 mw-100">
    <div class="navigation-bar-container d-flex flex-nowrap mx-auto position-relative">
      <ng-container *ngIf="product$ | async as product">
        <div class="transition-margin d-none d-lg-flex flex-column justify-content-center py-1">
          <dcp-product-name-display></dcp-product-name-display>
        </div>
      </ng-container>
      <div class="d-flex align-content-stretch text-nowrap mt-3">
        <ng-container *ngIf="navigationLinks">
          <a
            (click)="scrollToElement(navigationLink.id)"
            (keydown.enter)="scrollToElement(navigationLink.id)"
            *ngFor="let navigationLink of navigationLinks; let i = index"
            [class.active]="navigationLink.active"
            [class.ms-5]="i > 0"
            [id]="'pdp-nav-bar-' + navigationLink.id"
            [attr.data-cy]="'pdp-nav-bar-xl-' + navigationLink.id"
            class="navigation-link d-flex align-items-center ds-color--grey-1"
            tabindex="0"
          >
            <span class="navigation-link__text">
              {{navigationLink.headline | cxTranslate: navigationLink.headlineParams}}
            </span>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="d-sm-none w-100 position-relative">
    <div class="horizontal-scrolling-nav">
      <div class="horizontal-scrolling-nav__row">
        <ng-container *ngIf="navigationLinks">
          <a
            (click)="scrollToElement(navigationLink.id)"
            (keydown.enter)="scrollToElement(navigationLink.id)"
            *ngFor="let navigationLink of navigationLinks; let i = index"
            [class.pe-4]="i === navigationLinks.length - 1"
            [class.active]="navigationLink.active"
            [id]="'pdp-nav-bar-' + navigationLink.id"
            [attr.data-cy]="'pdp-nav-bar-sm-' + navigationLink.id"
            class="horizontal-scrolling-nav__item navigation-link ds-color--grey-2 d-flex align-items-center py-5"
            tabindex="0"
          >
            <span class="navigation-link__text">
              {{navigationLink.headline | cxTranslate: navigationLink.headlineParams}}
            </span>
          </a>
        </ng-container>
      </div>
    </div>
    <div class="fading-list-button--left"></div>
    <div class="fading-list-button--right"></div>
  </div>
  <div class="w-100 d-sm-none separator"></div>
</div>
